import * as React from 'react';
import Icons from '../icons';

export default class EmptyLetters extends React.Component {
    constructor(props){
        super(props);
    }

    render(){
        return(
            <div className="emptyScreen noLogsScreen">
                <Icons name="NoRecordsIllustration" className="icon" />    
                <h2>No Letter Found</h2>
                {
                    <p>There are no letters records available here</p>
                }
            </div>
        );
    }
}